<app-standard-layout>
    <page-body>
        <div class="col-md-12">
            <app-login-box></app-login-box>
        </div>
    </page-body>
</app-standard-layout>
